/**
 * @videoblocks/structured-data
 *
 * A unified Schema.org structured data generator for SEO optimization.
 *
 * Main API:
 * - generateSchema: Generate any supported schema type
 * - generateSchemas: Batch generation of multiple schemas
 *
 * @example
 * ```typescript
 * import { generateSchema, SCHEMA_TYPES } from '@videoblocks/structured-data';
 *
 * const contactPoint = generateSchema(SCHEMA_TYPES.CONTACT_POINT, {
 *   contactType: 'Customer Service',
 *   telephone: '+1-800-555-0123',
 *   email: 'support@example.com'
 * });
 * ```
 */

// ============================================================================
// Main API - Unified Schema Generator
// ============================================================================
export { generateSchema, generateSchemas, SCHEMA_TYPES } from './unifiedGenerator';

// ============================================================================
// Configuration API
// ============================================================================
export { updateConfig, resetConfig, config } from './config';

// ============================================================================
// Types - Essential for using the generator
// ============================================================================

// Re-export unified generator types
export type { SchemaType, SchemaTypeToInput, SchemaTypeToOutput, GenerationOptions } from './unifiedGenerator';
export type { NonStringThing } from './types/itemList';
